import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { authApi } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { user, signIn } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState(new URLSearchParams(window.location.search).get("mode") === "register" ? "register" : "login");
  const [f, setF] = useState({ email: "", password: "", name: "", company_name: "" });
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={user.role === "owner" || mode === "login" ? "/pro" : "/pro/prospekter"} replace />;

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = mode === "login"
        ? await authApi.login({ email: f.email, password: f.password })
        : await authApi.register(f);
      signIn(res);
      nav(mode === "register" ? "/pro/prospekter" : "/pro");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.toString() || "Noe gikk galt");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between bg-primary p-12 text-primary-foreground">
        <div className="flex items-center gap-2 font-heading text-xl font-extrabold"><Sparkles className="h-6 w-6" /> RenholdsPro</div>
        <div>
          <h1 className="font-heading text-5xl font-extrabold leading-tight">Hele renholdsbedriften din – på ett sted.</h1>
          <p className="mt-4 text-lg opacity-90">Kunder, kalender, tilbud, fakturaer, ansatte og prospektering av nye kunder.</p>
        </div>
        <p className="text-sm opacity-70">Laget for norske renholdsbedrifter</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="auth-form">
          <h2 className="font-heading text-3xl font-extrabold">{mode === "login" ? "Logg inn" : "Opprett bedrift"}</h2>
          {mode === "register" && (
            <>
              <div><Label>Bedriftsnavn</Label><Input data-testid="register-company-input" required value={f.company_name} onChange={set("company_name")} /></div>
              <div><Label>Ditt navn</Label><Input data-testid="register-name-input" required value={f.name} onChange={set("name")} /></div>
            </>
          )}
          <div><Label>E-post</Label><Input data-testid="login-email-input" type="email" required value={f.email} onChange={set("email")} /></div>
          <div><Label>Passord</Label><Input data-testid="login-password-input" type="password" required minLength={6} value={f.password} onChange={set("password")} /></div>
          <Button data-testid="auth-submit-button" type="submit" className="w-full h-11 font-bold" disabled={busy}>
            {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}{mode === "login" ? "Logg inn" : "Opprett konto"}
          </Button>
          <button type="button" data-testid="auth-toggle-mode" onClick={() => setMode(mode === "login" ? "register" : "login")} className="w-full text-sm text-muted-foreground hover:text-primary">
            {mode === "login" ? "Ny bedrift? Opprett konto gratis" : "Har du konto? Logg inn"}
          </button>
        </form>
      </div>
    </div>
  );
}
